import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

export default function SistemaRefill() {
  const pasos = [
    { num:'01', titulo:'Usa tu producto', desc:'Disfruta tu producto Wawita hasta terminarlo.' },
    { num:'02', titulo:'Guarda el envase', desc:'No botes el envase. Lavalo y guardalo hasta tu proxima compra.' },
    { num:'03', titulo:'Trae o solicita recarga', desc:'Visitanos en Pasto o solicita tu recarga por WhatsApp.' },
    { num:'04', titulo:'Ahorra y cuida el planeta', desc:'Obtien tu recarga con descuento especial y reduce residuos.' },
  ];
  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Sistema Refill' }]} />
      <div style={{ maxWidth:960, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,5vw,42px)', color:'var(--forest)', marginBottom:8 }}>Sistema de Refill</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:16 }} />
        <p style={{ fontSize:18, color:'var(--ink-light)', lineHeight:1.7, marginBottom:48, maxWidth:700 }}>
          Nuestro sistema de recarga es una alternativa inteligente para reducir residuos, ahorrar dinero y seguir disfrutando tus productos favoritos.
        </p>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px,1fr))', gap:20, marginBottom:60 }}>
          {pasos.map(p => (
            <div key={p.num} style={{ background:'#fff', borderRadius:16, padding:24, boxShadow:'var(--shadow-xs)', textAlign:'center' }}>
              <div style={{ fontFamily:'var(--font-display)', fontSize:40, color:'#9FBE6A', fontWeight:700, marginBottom:12 }}>{p.num}</div>
              <h3 style={{ fontFamily:'var(--font-display)', fontSize:17, color:'var(--forest)', marginBottom:10 }}>{p.titulo}</h3>
              <p style={{ fontSize:13, color:'var(--ink-light)', lineHeight:1.6 }}>{p.desc}</p>
            </div>
          ))}
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(260px,1fr))', gap:32, marginBottom:48 }}>
          <div style={{ background:'rgba(159,190,106,0.15)', borderRadius:20, padding:32 }}>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, color:'var(--forest)', marginBottom:16 }}>Beneficios para ti</h2>
            {['Descuento especial en recargas','Menos gasto en empaque','Mismo producto de alta calidad','Contribuyes al medio ambiente'].map(b => (
              <div key={b} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12, fontSize:14, color:'var(--forest)', fontWeight:600 }}>
                <span style={{ color:'#9FBE6A', fontSize:18 }}>✓</span> {b}
              </div>
            ))}
          </div>
          <div style={{ background:'var(--forest)', borderRadius:20, padding:32 }}>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, color:'#9FBE6A', marginBottom:16 }}>Beneficios para el planeta</h2>
            {['Menos plastico en el ambiente','Reduccion de residuos','Menor huella de carbono','Economia circular'].map(b => (
              <div key={b} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12, fontSize:14, color:'rgba(255,255,255,0.85)', fontWeight:500 }}>
                <span style={{ color:'#9FBE6A', fontSize:18 }}>✓</span> {b}
              </div>
            ))}
          </div>
        </div>
        <div style={{ background:'rgba(159,190,106,0.1)', borderRadius:16, padding:32, textAlign:'center' }}>
          <h3 style={{ fontFamily:'var(--font-display)', fontSize:22, color:'var(--forest)', marginBottom:12 }}>Solicita tu recarga</h3>
          <p style={{ fontSize:15, color:'var(--ink-light)', marginBottom:20 }}>Escribenos por WhatsApp y coordinamos tu recarga</p>
          <a href="https://wa.me/573113407979" target="_blank" rel="noreferrer" style={{ display:'inline-block', padding:'12px 32px', background:'#9FBE6A', color:'#1C3A1E', borderRadius:12, fontWeight:700, textDecoration:'none', fontSize:15 }}>Solicitar por WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
